namespace Matrix.Visualizer {
    export interface GraphInstanceRow {
        GraphInstanceId?: number;
        InstanceKey?: string;
        GraphKey?: string;
        ThemeKey?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace GraphInstanceRow {
        export const idProperty = 'GraphInstanceId';
        export const nameProperty = 'InstanceKey';
        export const localTextPrefix = 'Visualizer.GraphInstance';
        export const lookupKey = 'Visualizer.GraphInstance';

        export function getLookup(): Q.Lookup<GraphInstanceRow> {
            return Q.getLookup<GraphInstanceRow>('Visualizer.GraphInstance');
        }
        export const deletePermission = 'DataAdmin:Visualizer';
        export const insertPermission = 'DataAdmin:Visualizer';
        export const readPermission = 'Read:Visualizer';
        export const updatePermission = 'DataAdmin:Visualizer';

        export declare const enum Fields {
            GraphInstanceId = "GraphInstanceId",
            InstanceKey = "InstanceKey",
            GraphKey = "GraphKey",
            ThemeKey = "ThemeKey",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
